/**
 * Извлекает offerId из URL вида https://www.cian.ru/booking-calendar/{offer_id}/
 */
export const extractOfferIdFromBookingCalendarUrl = (url: string): string | null => {
  const match = url.match(/booking-calendar\/(\d+)/);

  return match ? match[1] : null;
};

/**
 * Генерирует deeplink для мобильного приложения для настроек календаря бронирования
 * @param offerId - ID оффера
 * @returns Deeplink URL
 */
export const generateBookingCalendarSettingsDeeplink = (offerId: string): string => {
  const baseUrl = 'https://cian.onelink.me/2426377992';
  const deepLinkValue = `cianurl://www.cian.ru/booking-calendar/${offerId}`;

  const params = new URLSearchParams({
    af_xp: 'custom',
    pid: 'nonpaid_mobilesite',
    af_dp: deepLinkValue,
    c: 'calendar_settings',
    deep_link_value: deepLinkValue,
  });

  return `${baseUrl}?${params.toString()}`;
};
